import { render } from "./Bg.vue?vue&type=template&id=16c7d8da&scoped=true"
import script from "./Bg.vue?vue&type=script&lang=js"
export * from "./Bg.vue?vue&type=script&lang=js"

import "./Bg.vue?vue&type=style&index=0&id=16c7d8da&scoped=true&lang=scss"

import exportComponent from "D:\\project\\2024\\htos\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16c7d8da"]])

export default __exports__